import { render, staticRenderFns } from "./MatchesCardByTeam.vue?vue&type=template&id=5ce646d6&scoped=true"
import script from "./MatchesCardByTeam.vue?vue&type=script&lang=js"
export * from "./MatchesCardByTeam.vue?vue&type=script&lang=js"
import style0 from "./MatchesCardByTeam.vue?vue&type=style&index=0&id=5ce646d6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ce646d6",
  null
  
)

export default component.exports